import { makeStyles } from '@material-ui/core/styles';

export const useDetailStyles = makeStyles((theme) => ({
    select: {
        '& .MuiSelect-select': {
            minWidth: 400,
        },
    },
    certContainer: {
        border: `1px solid ${theme.palette.divider}`,
        padding: theme.spacing(3),
        marginTop: theme.spacing(3),
    },
    keyValueContainer: {
        padding: theme.spacing(2),
        marginTop: theme.spacing(2),
        backgroundColor: theme.palette.type === 'light' ? '#efefef' : '#4a4a4a',
        maxHeight: 400,
        overflowY: 'scroll',
    },
}));
